import Layout from '../layout'
import TagList from './list'
import TagEditor from './editor'

const basePath = '/v-admin/crm-management/tag'

export default {
  path: basePath,
  component: Layout,
  meta: {
    permission: ['PERM_TAG_MANAGEMANT', 'PREMIUM_TAG_MANAGEMENT'],
    titleI18nKey: 'admin.crm.title.tag.management',
    menu: {
      labelI18nKey: 'admin.crm.menu.tag'
    }
  },
  children: [
    {
      name: 'tagList',
      path: '',
      component: TagList,
      meta: {
        titleI18nKey: 'admin.crm.title.tag.management',
        breadcrumb: { hidden: true }
      }
    },
    {
      name: 'addTag',
      path: `${basePath}/add`,
      component: TagEditor,
      meta: {
        titleI18nKey: 'admin.crm.title.tag.add'
      }
    },
    {
      name: 'editTag',
      path: `${basePath}/edit/:tagId`,
      component: TagEditor,
      meta: {
        titleI18nKey: 'admin.crm.title.tag.edit',
        isEditMode: true
      }
    }
  ]

}
